import './breadcrumb.sass';

export { default } from './breadcrumb';
